import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement, useContext } from "react";

import { TableContext } from "./Table.tsx";

export const TableHeader = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"th">): ReactElement => {
  const { bleed, grid } = useContext(TableContext);

  return (
    <th
      {...props}
      className={clsx(
        className,
        "border-b border-b-zinc-950/10 px-4 py-2 font-medium first:pl-[var(--gutter,theme(spacing.2))] last:pr-[var(--gutter,theme(spacing.2))] dark:border-b-white/10",
        grid &&
          "border-l border-l-zinc-950/5 first:border-l-0 dark:border-l-white/5",
        !bleed && "sm:first:pl-1 sm:last:pr-1",
      )}
    />
  );
};
